import { NLPBrainActionType } from "@swivl-mono/types";
import { Button, ButtonColor, Dropdown, Input, LineHeader } from "@swivl-mono/ui";
import { useState } from "react";
import { NavigateFunction } from "react-router-dom";
import { BrainsModel } from "../../../../Models/Brains/Brains.Model";
import ModalModel from "../../../../Models/Modal/Modal.Model";
import NLPModel from "../../../../Models/NLP/NLP.Model";
import "./AddBrainsModal.scss";

interface Props {
	navigate: NavigateFunction
}

export function AddBrainsModal(props: Props) {
	const { navigate } = props;
	const [loading, setLoading] = useState(false);
	const [selectedMenuItem, setSelectedMenuItem] = useState("NLP");
	const [brainName, setBrainName] = useState("New Brain");
	const [model, setModel] = useState(null);
	const [thresholds, setThresholds] = useState({ intent: 24, entity: 35 });

	const { cachesMap } = NLPModel.useState(state => state);

	const createNLPBrain = async () => {
		if (!model) {
			alert("Please select a model");
			return;
		}
		setLoading(true);

		const brain = await BrainsModel.createNLPBrain(
			brainName,
			{
				"actions": {
				},
				"unhandled": {
					"type": NLPBrainActionType.QUEST
				},
				"thresholds": {
					"entity": thresholds.entity * 0.01,
					"intent": thresholds.intent * 0.01
				}
			},
			{
				"appId": cachesMap![model].appId,
				"version": cachesMap![model].version
			}
		);

		setLoading(false);
		navigate(`/brain/${brain.slug}`)
		ModalModel.hideModal();
	}

	const createLLMBrain = async () => {
		if (!model) {
			alert("Please select a model");
			return;
		}
		setLoading(true);

		const brain = await BrainsModel.createLLMBrain(
			brainName,
			{
				prompt: "Please respond to the above messages.",
				numberOfMessagesToInclude: 15,
				numberOfTokensInResponse: 200
			},
			{
				"model": model,
			}
		);

		setLoading(false);
		navigate(`/brain/${brain.slug}`)
		ModalModel.hideModal();
	}

	return <div className="AddBrainsModal">
		<LineHeader
			menuItems={["NLP", "LLM"]}
			selectedMenuItem={selectedMenuItem}
			menuItemSelected={(selectedMenuItem) => {
				setModel(null);
				setSelectedMenuItem(selectedMenuItem)
			}} />
		{selectedMenuItem === "NLP" ? <div className="content">
			<label>BRAIN NAME</label>
			<Input value={brainName} onSet={setBrainName} />
			<label>MODEL</label>
			<Dropdown
				value={model}
				options={cachesMap && Object.keys(cachesMap).map(cacheId => ({ label: cachesMap[cacheId].name, value: cacheId }))}
				onSet={setModel}
			/>
			<label>INTENT THRESHOLD</label>
			<div className="threshold">
				<Input type={Input.Type.Integer} value={String(thresholds.intent)} onSet={(value) => {
					setThresholds({ ...thresholds, intent: Number(value) })
				}} />%
			</div>

			<label>ENTITY THRESHOLD</label>
			<div className="threshold">
				<Input type={Input.Type.Integer} value={String(thresholds.entity)} onSet={(value) => {
					setThresholds({ ...thresholds, entity: Number(value) })

				}} />%
			</div>
			<div className="buttons">
				<Button className="cancel" onClick={() => ModalModel.hideModal()}>CANCEL</Button>
				<Button color={ButtonColor.YELLOW} loading={loading} onClick={() => { createNLPBrain() }}>CREATE</Button>
			</div>
		</div> :
			<div className="content">
				<label>BRAIN NAME</label>
				<Input value={brainName} onSet={setBrainName} />
				<label>MODEL</label>
				<Dropdown
					value={model}
					options={[{ label: "GPT 3.5 Turbo", value: "gpt-3.5-turbo" }, { label: "GPT 4", value: "gpt-4" }]}
					onSet={setModel}
				/>

				<div className="buttons">
					<Button className="cancel" onClick={() => ModalModel.hideModal()}>CANCEL</Button>
					<Button color={ButtonColor.YELLOW} loading={loading} onClick={() => createLLMBrain()}>CREATE</Button>
				</div>
			</div>
		}
	</div>
}
